import React from 'react';
import { LazyImg } from 'src/hooks/useLazyLoad';
import { CustomLink } from 'src/components/CustomLink/CustomLink';
import { CarouselWithOrangeBlock } from 'src/components/CarouselWithOrangeBlock/CarouselWithOrangeBlock';

import classes from './CategoryList.scss';

export interface CategoryItem {
    image: string;
    link: string;
    title: string;
    widget_title?: string;
}

type CategoryListProps = {
    categories: CategoryItem[];
};

export const CategoryList: React.FC<CategoryListProps> = ({ categories }) => (
    <>
        <div className={classes.categoryList} data-test-id="categoryList">
            <h2>Browse Workwear by Category</h2>
            {categories.length > -1 && (
                <CarouselWithOrangeBlock
                    orangeTitle="Browse Workwear by Category"
                    additionalBlock
                    elements={categories}
                />
            )}
            <CustomLink link="/brands/carhartt" className={classes.clearance}>
                <LazyImg
                    className={classes.image}
                    src={require('../../../static/img/carhartt.jpg')}
                    alt="clearance image"
                />
            </CustomLink>
        </div>
        {/* {treatmentFooter === 'on' && titleArray && (
            <div>
                {Boolean(titleArray.length > 0 && isOpen) && (
                    <div className={classes.extendedDescription}>
                        {titleArray.map((title, index) => (
                            <div
                                key={index}
                                className={classnames(classes.content, {
                                    [classes.active]: isOpen[index].value,
                                })}
                            >
                                <button
                                    type="button"
                                    onClick={() => updateArrayElement(index, !isOpen[index].value)}
                                >
                                    <h3>{title}</h3>
                                    <Svg name={isOpen[index].value ? 'arrow-up' : 'arrow-down'} />
                                </button>
                                {descriptionArray[index] && (
                                    <p>
                                        <RichText content={descriptionArray[index]} />
                                    </p>
                                )}
                            </div>
                        ))}
                    </div>
                )}
            </div>
        )} */}
    </>
);
